
import { Component, Vue } from "vue-property-decorator";
import { DropdownPlugin } from "bootstrap-vue";
import { NavPlugin } from "bootstrap-vue";
import { BFormInput } from "bootstrap-vue";
import { BButton } from "bootstrap-vue";
import { BNavbarNav } from "bootstrap-vue";
import { BNavbar } from "bootstrap-vue";
import { BIcon, BIconSearch, BIconList } from "bootstrap-vue";
import SearchBar from "@/components/SearchBar.vue"

Vue.component("b-navbar", BNavbar);
Vue.component("b-navbar-nav", BNavbarNav);
Vue.component("b-button", BButton);
Vue.component("b-form-input", BFormInput);
Vue.use(NavPlugin);
Vue.use(DropdownPlugin);
@Component({
  components: {
    BIcon,
    BIconSearch,
    BIconList,
    SearchBar,
  },
})

export default class Menu extends Vue {
  protected showBurger= false;
  protected ToogleShowBurger(): void {
    if (this.showBurger == false) {this.showBurger = true;}
    else {
      this.showBurger = false;
    }
  }
  protected created() {
    if (screen.width < 600) {
      this.showBurger = false;
    } else {
      this.showBurger = true;
    }
  }
}
